import { render } from "./MenuMobileWrapper.vue?vue&type=template&id=513463a8&scoped=true"
import script from "./MenuMobileWrapper.vue?vue&type=script&lang=js"
export * from "./MenuMobileWrapper.vue?vue&type=script&lang=js"

import "./MenuMobileWrapper.vue?vue&type=style&index=0&id=513463a8&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513463a8"]])

export default __exports__